import { useSkeletonOpacity } from "@/src/components/news/loading-skeleton/news-card-skeleton";
import { Animated, View } from "react-native";

const Block = ({ className, style }: { className: string; style?: object }) => (
  <View className={`rounded-md bg-ash-3 ${className}`} style={style} />
);

export const LatestNewsSkeleton = ({
  isMobile = false,
}: {
  isMobile?: boolean;
}) => {
  const opacity = useSkeletonOpacity();

  return (
    <Animated.View
      style={{ opacity }}
      className="flex-row flex-1 gap-4 bg-obsidian"
    >
      <View className="flex-1 flex-col bg-chalk rounded-2xl gap-4">
        <View
          className="flex-row flex-1 gap-4 mt-4"
          style={{ minHeight: 0, overflow: "hidden" }}
        >
          <LargeNewsCardSkeleton />

          <View className="flex-1 gap-3">
            {[0, 1, 2, 3].map((i) => (
              <SmallNewsCardSkeleton key={i} />
            ))}
          </View>
        </View>
      </View>
    </Animated.View>
  );
};

function LargeNewsCardSkeleton() {
  return (
    <View className="flex-1 border border-ash-3 rounded-xl p-3 gap-3 bg-chalk">
      <View className="flex-row justify-between items-center">
        <View className="flex-row gap-2 items-center flex-1">
          <Block className="h-9 w-9 rounded-full" />
          <View className="gap-1">
            <Block className="h-3 w-28" />
            <Block className="h-3 w-16" />
          </View>
        </View>
        <Block className="h-5 w-5 rounded-md" />
      </View>

      <View className="gap-2" style={{ minHeight: 48 }}>
        <Block className="h-5 w-4/5" />
        <Block className="h-5 w-3/5" />
      </View>

      <View className="flex-row items-center gap-2">
        <Block className="h-3 w-12" />
        <Block className="h-3 w-16" />
        <Block className="h-3 w-14" />
      </View>

      <View className="gap-2" style={{ minHeight: 60 }}>
        <Block className="h-3 w-full" />
        <Block className="h-3 w-11/12" />
        <Block className="h-3 w-3/4" />
      </View>

      <Block className="w-full rounded-xl" style={{ height: 205 }} />
    </View>
  );
}

function SmallNewsCardSkeleton() {
  return (
    <View className="p-3 border border-ash-3 rounded-xl flex-row gap-3 bg-chalk">
      <Block className="rounded-xl" style={{ width: "40%", height: 80 }} />

      <View className="flex-1">
        <View className="flex-row justify-between items-start mb-2 gap-2">
          <View className="flex-1 gap-1">
            <Block className="h-3 w-full" />
            <Block className="h-3 w-5/6" />
          </View>
          <Block className="h-5 w-5 rounded-md" />
        </View>

        <View className="flex-row items-center gap-2">
          <Block className="h-3 w-10" />
          <Block className="h-3 w-14" />
        </View>
      </View>
    </View>
  );
}
